import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { Fragment } from 'react';
import { shape, number, node, func } from 'prop-types';
import MenuFooter from '../MenuFooter';
import { LinksList, LinkItem, MenuBox, Link, LinksWrapper, BannerWrapper, ContentWrapper, SubsectionTitle } from './menu-content.styles';
import { HorizontalRule } from '../../atoms';

const MenuContent = _ref => {
  let {
    data
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["data"]);

  const {
    subcategoriesList,
    url: categoryUrl,
    label: categoryLabel,
    borderColor,
    banner,
    footerData,
    linePerCol = 16,
    subsections
  } = data;
  const {
    onMenuItemClick
  } = props;
  return /*#__PURE__*/React.createElement(MenuBox, {
    "data-testid": "menu-box-elem",
    borderColor: borderColor
  }, /*#__PURE__*/React.createElement(ContentWrapper, null, subcategoriesList ? /*#__PURE__*/React.createElement(LinksWrapper, null, /*#__PURE__*/React.createElement(LinksList, {
    lines: linePerCol
  }, subcategoriesList.map((link, index) => /*#__PURE__*/React.createElement(LinkItem, {
    key: `link-item-${index}`
  }, /*#__PURE__*/React.createElement(Link, _extends({}, link.highlight ? {
    color: borderColor
  } : {}, {
    href: link.url,
    onClick: e => onMenuItemClick(e, link, 'departamento')
  }), link.label))), subsections ? subsections.map((subsection, index) => {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: `subsection-${index}`
    }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(SubsectionTitle, {
      key: `subsection-title-${index}`
    }, subsection.label), subsection.linksList.map((subsectionLink, indexLink) => /*#__PURE__*/React.createElement(LinkItem, {
      key: `subsection-link-item-${index}-${indexLink}`
    }, /*#__PURE__*/React.createElement(Link, {
      onClick: e => onMenuItemClick(e, subsectionLink, 'subsection'),
      href: subsectionLink.url
    }, subsectionLink.label))));
  }) : /*#__PURE__*/React.createElement(React.Fragment, null)), categoryUrl && categoryUrl !== '#' && categoryLabel ? /*#__PURE__*/React.createElement(Link, {
    color: borderColor,
    href: categoryUrl
  }, "+ ", categoryLabel) : /*#__PURE__*/React.createElement(React.Fragment, null)) : /*#__PURE__*/React.createElement(React.Fragment, null), banner && banner.component && /*#__PURE__*/React.createElement(BannerWrapper, {
    "data-testid": "banner-elem",
    width: banner.width
  }, banner.component)), footerData ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HorizontalRule, null), /*#__PURE__*/React.createElement(MenuFooter, {
    data: footerData,
    onMenuFooterClick: (e, label) => onMenuItemClick(e, label, 'footer')
  })) : /*#__PURE__*/React.createElement(React.Fragment, null));
};

MenuContent.defaultProps = {
  onMenuItemClick: () => ({}),
  data: {}
};
process.env.NODE_ENV !== "production" ? MenuContent.propTypes = {
  onMenuItemClick: func,
  data: shape({
    banner: shape({
      component: node,
      width: number
    })
  })
} : void 0;
export default MenuContent;